import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackEscrowLabelClick, trackReliableLabelClick, trackReliableLabelHover } from './tracking';
import {
  LabelsLayout,
  ReliableLabelTooltip,
  EscrowLabel,
  EscrowLabelTooltip,
  DiscountMortgageTooltip,
  ReliableLabelV2,
} from '../../components/Labels';
import {
  isReliableSelector,
  getNewbuildingId,
  isEscrowSelector,
  getDiscountMortgage,
  getReliableLabel,
} from '../../selectors/newbuilding';
import { reliabilityEnabledSelector } from '../../selectors/reliability';

export function LabelsContainer() {
  const hasDiscountMortgage = useSelector(getDiscountMortgage);
  const isReliable = useSelector(isReliableSelector);
  const isReliabilityV2Enabled = useSelector(reliabilityEnabledSelector);
  const isEscrow = useSelector(isEscrowSelector);
  const newbuildingId = useSelector(getNewbuildingId);
  const reliableLabel = useSelector(getReliableLabel);

  const onReliableLabelHover = React.useCallback(() => {
    trackReliableLabelHover(newbuildingId);
  }, [newbuildingId]);

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackReliableLabelClick();
  };

  const onEscrowLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#escrow',
      offset: 100,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackEscrowLabelClick();
  };

  return (
    <LabelsLayout>
      {hasDiscountMortgage && <DiscountMortgageTooltip />}
      {isReliable && !isReliabilityV2Enabled && (
        <ReliableLabelTooltip onOpen={onReliableLabelHover} onClick={onReliableLabelClick} />
      )}
      {reliableLabel && isReliabilityV2Enabled && (
        <ReliableLabelV2 label={reliableLabel.title} reliableType={reliableLabel.type} onClick={onReliableLabelClick} />
      )}
      {isEscrow && <EscrowLabelTooltip label={<EscrowLabel onClick={onEscrowLabelClick} />} />}
    </LabelsLayout>
  );
}
